import SCPPrint from '../assets/js/SCPPrint_v2.7';



// install 函数用于初始化顺丰打印 SDK 并设置打印机
export function installPrintService(options) {


    // sdkCallback 用于处理 SDK 调用返回结果
    const sdkCallback = result => {
        console.info(result)
              switch (result.code) {
                  case 1:
                      console.info("SF SCPPrint Created successfully..................");
                      break;
                  case 2:
                      console.error("SF C-Lodop plugin is not installed or started, Plugin download URL: " + result.downloadUrl);
                      break;
                  case 3:
                      console.error("SF C-Lodop print plug-in version needs to be upgraded, Plugin download URL: " + result.downloadUrl);
                      break;
                  case 4:
                      console.error("The page has not been downloaded yet, please wait for a while..............");
                      break;
                  default:
                      console.error("Unknown error code:", result.code);
                      break;
              }
    };

    // sdkParams 用于传递初始化配置
    const sdkParams = {
        env: options.env || 'pro',  // 默认值为生产环境
        partnerID: options.partnerID,
        callback: sdkCallback,
        notips: options.notips || false // 不弹框提示（默认 false）
    };

    // 创建顺丰打印 SDK 实例
    const sfPrintSdk = new SCPPrint(sdkParams);
    sfPrintSdk.projectCode = options.projectCode;

    console.info("Create SF Object Success.....................................");
    // 获取打印机列表
    const getPrintersCallback = result => {
        if (result.code === 1) {
            const printers = result.printers;
            console.info("Printers list:", printers);
            // let printerIndex = 0; // 默认打印机索引
            // let HP_Pinter = -1;
            // let Zebra_Pinter = -1;
            // // 遍历打印机列表，选择匹配的打印机
            // printers.forEach((item, index) => {
            //     if (item.name === 'HP LaserJet Professional M1213nf MFP') {
            //         HP_Pinter = index; // 设置匹配打印机的索引
            //     }else if (item.name.indexOf('Zebra') >= 0 ){
            //         Zebra_Pinter = index;
            //     }
            // });
            //
            // if (Zebra_Pinter >= 0){
            //     printerIndex = Zebra_Pinter;
            // }else if (HP_Pinter >= 0){
            //     printerIndex = HP_Pinter;
            // }
            // 设置默认打印机
            // sfPrintSdk.setPrinter(printerIndex);
        } else {
            console.error("Failed to get the printer list...................");
        }
    };

    // 调用获取打印机列表的接口
    sfPrintSdk.getPrinters(getPrintersCallback);

    return sfPrintSdk; // 返回打印 SDK 实例
}



//
//
// export function install(options) {
//             console.info("创建顺丰打印对象 。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。")
//             const sdkCallback = result => {
//                 if (result.code == 1){
//                     console.info("SF SCPPrint Created successfully..................")
//                 }else if (result.code == 2){
//                     console.error("SF C-Lodop plugin is not installed or started,Plugin download URL: " + result.downloadUrl)
//                     // if (sfPrintSdk){
//                     //     console.info("取消初始化")
//                     //     sfPrintSdk = null; // 取消初始化
//                     // }
//                 }else if (result.code == 3 ){
//                     console.error("SF C-Lodop print plug-in version needs to be upgraded,Plugin download URL: "+ result.downloadUrl)
//                     // if (sfPrintSdk){
//                     //     console.info("取消初始化")
//                     //     sfPrintSdk = null; // 取消初始化
//                     // }
//                 }else if (result.code == 4){
//                     console.error("The page has not been downloaded yet, please wait for a while..............")
//                     // if (sfPrintSdk){
//                     //     console.info("取消初始化")
//                     //     sfPrintSdk = null; // 取消初始化
//                     // }
//                 }
//             };
//
//
//             const sdkParams = {
//                 env: options.env, // 生产：pro；沙箱：sbox。不传默认生产，转生产需要修改这里
//                 partnerID: options.partnerID,
//                 callback: sdkCallback,
//                 notips: options.notips    // 不弹框提示
//             };
//
//             let  sfPrintSdk = new SCPPrint(sdkParams);
//              sfPrintSdk.projectCode = options.projectCode;
//
//             // 获取打印机列表
//             const getPrintersCallback = result => {
//                 if (result.code === 1) {
//                     let  printers = result.printers;
//                     console.info(printers)
//                     // 设置默认打印机
//                     var printer = 0;
//
//                     // 渲染打印机选择框下拉值
//                     for (let i = 0; i < printers.length; i++) {
//                         let item = printers[i];
//
//                         if (item.name == 'HP LaserJet Professional M1213nf MFP'){
//                             printer = item.index;
//                         }
//                     }
//                     sfPrintSdk.setPrinter(printer);
//                 }else {
//                     console.error("Failed to get the printer list...................")
//                 }
//             };
//             sfPrintSdk.getPrinters(getPrintersCallback);
//           return sfPrintSdk;
//     };